import React, { useEffect, useState } from "react";
import { Select, Modal, Input, DatePicker, InputNumber,Dropdown,Menu, Spin } from "antd";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import DEATH_API from "../../apis/death.api";
import { useTheme } from "../../utils/ThemeContext";
import swal from "sweetalert";
import moment from "moment";
import "./upcomingBills.css";

const UpcomingBillsTable = () => {
  const { theme } = useTheme();

  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const [loading, setLoading] = useState(false);
  const [billList, setBillList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState(null);

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleAddBill = async () => {
    if(formData && formData.id){
      try {
        setLoading(true);
        setIsModalVisible(false);
        let res = await DEATH_API.updateBills(formData.id,formData);
        if (res && res.status === 204) {
          await getBills();
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error while trying to updating bill==>", error);
      }
    }else{
      try {
        setLoading(true);
        setIsModalVisible(false);
        let payload = {
          payeeName: formData && formData.payeeName,
          note: formData && formData.note,
          amount: formData && formData.amount,
          dueDate: formData && formData.dueDate,
          // ? moment(formData.dueDate).format("YYYY-MM-DDTHH:mm:ssZ")
          // : "",
        };
        let res = await DEATH_API.addBills({ billsToPayForm: [payload] });
        if (res && res.status === 201) {
          await getBills();
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error while trying to create google task==>", error);
      }
    }
    setFormData(null);
  };
  const getBills = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchBills(ID);
      setLoading(false);
      if (data && data.data) {
        setBillList(data.data);
      }
    } catch (error) {
      console.error("Error fetching bills:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };
  const handleCancelModal = () => {
    setIsModalVisible(false);
    setFormData(null);
  };
  const getSelectedRow=(data)=>{
    setFormData(data);
    setIsModalVisible(true);
  }

  const deleteSelectedRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          const res = await DEATH_API.deleteBills(idx);
          setLoading(false);
          if (res && res.status === 200) {
            swal("Deleted!", "Your Upcoming Bill has been deleted.", "success");
            await getBills();
          }
        } catch (error) {
          console.log("error deleting Bills to pay");
          console.log(error);
        }
      } else {
        swal("Cancelled", "Your Bill is safe :)", "error");
      }
    });
  };

  useEffect(() => {
    if (userRole !== "trustee") {
      getBills();
    }
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3
            style={{
              color: theme === "light" ? "#232323" : "white",
            }}
          >
            Upcoming Bills
          </h3>
          {/* <Select
              labelInValue
              defaultValue={{ value: "Select", label: "Select" }}
              style={{ width: 120 }}
              onChange={() => {}}
              options={[
                { value: "July", label: "July" },
                { value: "August", label: "August" },
                { value: "October", label: "October" },
              ]}
            /> */}
          { localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" && (<button className="addBillsButton" onClick={handleOpenModal}>
            Add Bill
          </button>)}
        </div>

        <div
          style={{
            backgroundColor: theme === "dark" ? "#232323" : "white",
          }}
          className="main-dashboad-table-container"
        >
          <div className="table-wrapper">
            <table
              className={theme == "dark" ? "custom-table-dark" : "custom-table"}
            >
              <thead
                style={{
                  backgroundColor: theme === "dark" ? "#232323" : "white",
                }}
              >
                <tr
                  style={{
                    fontWeight: "700",
                  }}
                >
                  <th
                    style={{
                      color: theme === "dark" ? "#ffffff" : "#232323",
                    }}
                  >
                    Bill
                  </th>
                  <th
                    style={{
                      color: theme === "dark" ? "#ffffff" : "#232323",
                    }}
                  >
                    Due Date
                  </th>
                  <th
                    style={{
                      color: theme === "dark" ? "#ffffff" : "#232323",
                    }}
                  >
                    Amount
                  </th>
                  <th
                    style={{
                      color: theme === "dark" ? "#ffffff" : "#232323",
                    }}
                  >
                    Notes
                  </th>
                  <th
                    style={{
                      color: theme === "dark" ? "#ffffff" : "#232323",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody
                style={{
                  backgroundColor: theme === "dark" ? "#232323" : "white",
                }}
              >
                {billList && billList.length > 0 ? (
                  billList.map((bill) => (
                    <tr key={bill.id}>
                      <td
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                      >
                        {bill.payeeName ? bill.payeeName : "N/A"}
                      </td>
                      <td
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                      >
                        {new Date(bill.dueDate).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })}
                      </td>
                      <td
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                      >
                        $
                        {bill.amount
                          ? bill.amount
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : (0).toFixed(2)}
                      </td>
                      <td
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        title={bill.note ? bill.note :""}
                      >
                        {bill.note
                          ? bill.note.length > 15
                            ? bill.note.substring(0, 15) + ".."
                            : bill.note
                          : "N/A"}
                      </td>
                      <td
                      style={{
                        color: theme === "light" ? "#232323" : "white",
                      }}
                    >
                    <Dropdown
                    trigger={["click"]}
                    overlay={
                      <Menu>
                        <Menu.Item>
                          <div
                            onClick={() => {
                              console.log("deleete");
                              getSelectedRow(bill);
                            }}>
                            Update
                          </div>
                        </Menu.Item>
                        <Menu.Item
                        >
                          <div
                            onClick={() => {
                              console.log("deleete")
                              deleteSelectedRow(bill.id);
                            }}>
                            Delete
                          </div>
                        </Menu.Item>
                      </Menu>
                    }>
                    <a
                      className="ant-dropdown-link"
                      style={{padding: "0px 16px",}}
                      onClick={(e) => e.preventDefault()}>
                      <img src={menuIcon} width={4} height={16} alt="icon"></img>
                    </a>
                  </Dropdown>
                    </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      style={{
                        color: theme === "light" ? "#232323" : "white",
                        textAlign: "center",
                      }}
                    >
                      {loading ? "Loading..." : "No data to show"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal
        visible={isModalVisible}
        onOk={handleAddBill}
        onCancel={handleCancelModal}
        footer={null}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">Add Upcoming Bill</h3>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <h3 className="inputTitle">Bill Description</h3>
          <Input
            placeholder="Bill Description"
            value={formData && formData.payeeName}
            name="payeeName"
            onChange={(e) => {
              handleInputChange(e.target.name, e.target.value);
            }}
          />
        </div>

        <div style={{ marginBottom: "10px" }}>
          <h3 className="inputTitle">Bill Due Date</h3>
          <DatePicker
            style={{
              width: "100%",
              border: "1px solid #d1d5db",
              borderRadius: "5px",
            }}
            // showTime={{ format: "hh:mm A" }}
            format={"MM/DD/YYYY"}
            disabledDate={(current) => {
              let customDate = moment().format("YYYY-MM-DD");
              return current && current < moment(customDate, "YYYY-MM-DD");
            }}
            name="dueDate"
            size="large"
            id="newDate"
            onChange={(date, dateString) => {
              handleInputChange("dueDate", dateString);
            }}
            value={formData && formData.dueDate && moment(formData.dueDate)}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <h3 className="inputTitle">Bill Amount</h3>
          <div className="inputWrapper" style={{ display: "flex" }}>
            <span className="dollarSignInput">$</span>
            <InputNumber
              step={1}
              formatter={(value) =>
               value && `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Bill Amount"
              name="amount"
              value={formData && formData.amount}
              id="amount"
              onChange={(value) => {
                handleInputChange("amount", value);
              }}
            />
          </div>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <h3 className="inputTitle">Notes</h3>
          <Input
            placeholder="Notes"
            value={formData && formData.note}
            name="note"
            onChange={(e) => {
              handleInputChange(e.target.name, e.target.value);
            }}
          />
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancelModal();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            onClick={() => {
              handleAddBill();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
      {loading ? (
        <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
          <Spin size="large" />
        </div>
      ) : null}
    </div>
  );
};

export default UpcomingBillsTable;
